import { useMutation, useQueryClient, type QueryKey } from "@tanstack/react-query";
import { toast } from "sonner";
import { promoteItem } from "@/lib/api";

/**
 * Hook générique pour "renvoyer en avant" un item dans le carrousel.
 * Met à jour `promoted_at` sur n'importe quelle collection PocketBase
 * disposant de ce champ (`photos`, `weather_cards`, ...).
 */
export function usePromoteItem(opts: {
  collection: string;
  invalidateKey: QueryKey;
  invalidateKeys?: QueryKey[];
  successToast?: string;
  errorToast?: string;
}) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (itemId: string) => promoteItem(opts.collection, itemId),
    onSuccess: (result) => {
      if (!result.ok) {
        toast.error(opts.errorToast ?? result.error);
        return;
      }
      qc.invalidateQueries({ queryKey: opts.invalidateKey });
      for (const key of opts.invalidateKeys ?? []) {
        qc.invalidateQueries({ queryKey: key });
      }
      if (opts.successToast) toast.success(opts.successToast);
    },
  });
}
